import create from './create'
import toggle from './toggle'

export default {
    create,
    toggle
}